import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .help': {
      '&-email': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          padding: theme.spacing(2),
        },
        '&-label': {
          color: theme.palette.text.hint,
        },
        '&-link': {
          color: theme.palette.text.secondary,
        },
      },
      '&-menu-item-link': {
        color: theme.palette.text.primary,
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'none',
        },
      },
      '&-menu-item': {
        '&-text': {
          flexGrow: 1,
        },
        '&-icon': {
          color: theme.palette.text.hint,
          marginLeft: theme.spacing(2),
        },
      },
    },
  },
  menuItem: {
    height: theme.spacing(6),
  },
}));

export default styles;
